<template>
    <section class="operations-strip mb-4" aria-label="Indicatori operativi Mail Segnalazioni">
        <div class="operations-strip__lead">
            <v-icon color="primary" class="mr-2">mdi-chart-timeline-variant</v-icon>
            <div>
                <div class="overline">Cruscotto operativo</div>
                <div class="caption grey--text text--darken-1">{{ metrics.scope || "coda persistita" }}</div>
            </div>
        </div>
        <button
            v-for="indicator in indicators"
            :key="indicator.id"
            type="button"
            class="operations-strip__metric"
            :class="{ 'operations-strip__metric--alert': indicator.alert }"
            :disabled="!indicator.actionable"
            :title="indicator.detail || indicator.label"
            @click="$emit('select-indicator', indicator.id)"
        >
            <v-icon small :color="indicator.color">{{ indicator.icon }}</v-icon>
            <strong>{{ indicator.value }}</strong>
            <span>{{ indicator.label }}</span>
        </button>
    </section>
</template>

<script>
export default {
    name: "MailSegnalazioniDashboard",
    props: {
        metrics: { type: Object, default: () => ({}) },
    },
    computed: {
        indicators() {
            const available = this.metrics.available !== false && Object.keys(this.metrics).length > 0;
            const count = (value) => available && value != null ? value : "n.d.";
            const hours = this.metrics.average_take_charge_hours;
            const acceptance = Object.prototype.hasOwnProperty.call(this.metrics, "automatic_feedback_acceptance_rate")
                ? this.metrics.automatic_feedback_acceptance_rate : this.metrics.automatic_recognition_rate;
            const hasDocumentCount = Object.prototype.hasOwnProperty.call(this.metrics, "nc_document_count");
            const accepted = this.metrics.automatic_feedback_accepted;
            const feedbackTotal = this.metrics.automatic_feedback_total;
            const feedbackDetail = available && accepted != null && feedbackTotal != null
                ? `${accepted} confermate su ${feedbackTotal} proposte automatiche con esito`
                : "Proposte automatiche confermate fra quelle con un feedback; non tutte le email";
            return [
                { id: "active", label: "bozze attive", value: count(this.metrics.active_drafts), icon: "mdi-inbox-arrow-down-outline", color: "primary", actionable: available },
                { id: "overdue", label: "oltre SLA", value: count(this.metrics.overdue), icon: "mdi-clock-alert-outline", color: "error", alert: available && Number(this.metrics.overdue) > 0, actionable: available },
                { id: "unassigned", label: "non assegnate", value: count(this.metrics.unassigned), icon: "mdi-account-question-outline", color: "warning", alert: available && Number(this.metrics.unassigned) > 0, actionable: available },
                { id: "recognition", label: "proposte confermate", value: !available || acceptance == null ? "n.d." : `${acceptance}%`, detail: feedbackDetail, icon: "mdi-target-account", color: "success" },
                { id: "closure", label: "presa in carico media", value: !available || hours == null ? "n.d." : `${hours} h`, icon: "mdi-timer-check-outline", color: "info" },
                { id: "nc-documents", label: hasDocumentCount ? "NC distinte" : "messaggi con NC", value: count(hasDocumentCount ? this.metrics.nc_document_count : this.metrics.nc_created), detail: hasDocumentCount ? "Documenti NC distinti; non equivale al numero dei messaggi completati" : "Messaggi collegati a una NC; il documento può ricorrere più volte", icon: "mdi-shield-check-outline", color: "success", actionable: false },
                { id: "completed", label: "messaggi completati", value: count(this.metrics.terminal_messages), detail: "Messaggi con NC oppure gestiti senza NC; apri la coda completati", icon: "mdi-email-check-outline", color: "success", actionable: available && this.metrics.terminal_messages != null },
            ];
        },
    },
};
</script>

<style scoped>
.operations-strip { display: flex; align-items: stretch; overflow-x: auto; border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 6px; background: var(--v-background-base); }
.operations-strip__lead { display: flex; align-items: center; min-width: 190px; padding: 10px 14px; border-right: 1px solid rgba(0, 0, 0, 0.1); }
.operations-strip__metric { display: grid; grid-template-columns: 22px auto; grid-template-rows: auto auto; column-gap: 7px; min-width: 145px; padding: 10px 14px; color: inherit; text-align: left; border: 0; border-right: 1px solid rgba(0, 0, 0, 0.08); background: transparent; cursor: pointer; }
.operations-strip__metric:hover, .operations-strip__metric:focus-visible { background: rgba(25, 118, 210, 0.06); outline: 2px solid transparent; }
.operations-strip__metric:disabled { cursor: default; }
.operations-strip__metric:disabled:hover { background: transparent; }
.operations-strip__metric strong { font-size: 1.05rem; line-height: 1.2; }
.operations-strip__metric span { grid-column: 2; font-size: 0.72rem; color: rgba(0, 0, 0, 0.62); white-space: nowrap; }
.operations-strip__metric--alert { background: rgba(244, 67, 54, 0.05); }
</style>
